import { IdType } from "./BaseTypes";
import { FileType } from "./File";

export const FILTER_DISPLAY = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
} as const;
export type FilterDisplayType =
  (typeof FILTER_DISPLAY)[keyof typeof FILTER_DISPLAY];

export const FILTER_INPUT = {
  CUSTOM: "custom",
  DEFINED: "defined",
} as const;
export type FilterInputType = (typeof FILTER_INPUT)[keyof typeof FILTER_INPUT];

export const FILTER_DATA = {
  NUMBER: "number",
  STRING: "string",
} as const;

export type FilterDataType = (typeof FILTER_DATA)[keyof typeof FILTER_DATA];

// Array of values for mapping
export const PROPERTY_DATA_VALUES = Object.values(
  FILTER_DATA,
) as FilterDataType[];

export const FILTER_OUTPUT = {
  SINGLE: "single",
  RANGE: "range",
  MULTI: "multi",
} as const;
export type FilterOutputType =
  (typeof FILTER_OUTPUT)[keyof typeof FILTER_OUTPUT];

export const FILTER_OPERATIONS = {
  GTE: "$gte",
  EQ: "$eq",
  LTE: "$lte",
  IN: "$in",
} as const;
export type FilterOperationType =
  (typeof FILTER_OPERATIONS)[keyof typeof FILTER_OPERATIONS];

export type FilterOptionsNumber = {
  dataType: "number";
  options: number[];
};

export type FilterOptionsString = {
  dataType: "string";
  options: string[];
};

export type FilterOptions = FilterOptionsNumber | FilterOptionsString;

export type FilterBase = {
  _id: IdType;
  title: string;
  description: string;
  display: FilterDisplayType;
  regex: string;
  inputType: FilterInputType;
  outputType: FilterOutputType;
  operations: FilterOperationType[];
  required: boolean;
  iconUrl?: FileType;
  unit?: string;
};
export type FilterType = FilterBase & FilterOptions;
// POST: _id is not included
export type FilterPostType = Omit<FilterBase, "_id"> & FilterOptions;

// PUT: same as full type
export type FilterPutType = FilterType;
